// Mirrors the currentPage/pageSize contract every paginated Mobius endpoint shares
export const API_DEFAULT_PAGE_SIZE = 10;
export const API_MAX_PAGE_SIZE = 1000;

export interface ApiPage<T> {
  items: T[],
  limit: number,
  offset: number,
  total: number
}

export function pageParams(currentPage: number, pageSize: number = API_DEFAULT_PAGE_SIZE) {
  return { currentPage, pageSize };
}
